// src/scripts/fluco-lib/events.js
var EVENTS = {
  SHOPIFY_BLOCK_SELECT: "shopify:block:select",
  SHOPIFY_BLOCK_DESELECT: "shopify:block:deselect",
  SHOPIFY_SECTION_DESELECT: "shopify:section:deselect",
  SHOPIFY_SECTION_SELECT: "shopify:section:select",
  SHOPIFY_SECTION_LOAD: "shopify:section:load",
  SHOPIFY_SECTION_UNLOAD: "shopify:section:unload",
  COUNTDOWN_TIMER_COMPLETED_EVENT: "fluco_section:countdown_timer_completed"
};
var events_default = EVENTS;

// src/scripts/sections/collection-list.js
var { SHOPIFY_BLOCK_SELECT, SHOPIFY_BLOCK_DESELECT } = events_default;
var CollectionList = class extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      collectionListSwappableMedia: "fluco-collection-list-swappable-media",
      listItemsParent: "[js-list-items-parent]"
    };
  }
  connectedCallback() {
    this.swappableMediaComponent = this.querySelector(
      this.selectors.collectionListSwappableMedia
    );
    this.listItemsParent = this.querySelector(this.selectors.listItemsParent);
    this.listItemsArray = Array.from(this.listItemsParent.children);
    this.eventController = new AbortController();
    this.eventOptions = { signal: this.eventController.signal };
    this.parentElement.addEventListener(
      SHOPIFY_BLOCK_SELECT,
      (e) => this.handleBlockSelected(e.detail.blockId),
      this.eventOptions
    );
    this.parentElement.addEventListener(
      SHOPIFY_BLOCK_DESELECT,
      () => this.handleBlockDeselected(),
      this.eventOptions
    );
    this.resetEventTypes = ["mouseleave", "focusout"];
    this.resetEventTypes.forEach(
      (type) => this.listItemsParent.addEventListener(
        type,
        (e) => this.setSwappableMediaActiveBlock(""),
        this.eventOptions
      )
    );
    this.setEventTypes = ["mouseenter", "focus"];
    this.listItemsArray.forEach(
      (item) => this.setEventTypes.forEach(
        (type) => item.addEventListener(
          type,
          (e) => this.setSwappableMediaActiveBlock(
            e.target.getAttribute("data-block-id")
          ),
          this.eventOptions
        )
      )
    );
  }
  disconnectedCallback() {
    this.eventController.abort();
  }
  /**
   * Changes to the selected block's media.
   * @param {String} blockId - The block ID for the selected block.
   */
  handleBlockSelected(blockId) {
    this.setSwappableMediaActiveBlock(blockId);
  }
  /**
   * Resets the selected block.
   */
  handleBlockDeselected() {
    this.setSwappableMediaActiveBlock("");
  }
  /**
   * Sets the swappable media's active block id.
   * @param {String} blockId - The block ID for the selected block.
   */
  setSwappableMediaActiveBlock(blockId) {
    if (this.swappableMediaComponent) {
      if (blockId !== "") {
        this.swappableMediaComponent.setAttribute(
          "data-active-block-id",
          blockId
        );
      } else {
        this.swappableMediaComponent.removeAttribute("data-active-block-id");
      }
    }
  }
};
var CollectionListSwappableMedia = class extends HTMLElement {
  static observedAttributes = ["data-active-block-id"];
  connectedCallback() {
    this.swappableMediaArray = Array.from(this.children);
  }
  disconnectedCallback() {
  }
  attributeChangedCallback(name, _oldValue, newValue) {
    switch (name) {
      case "data-active-block-id":
        if (newValue !== "") {
          this.showBlockMedia(newValue);
        } else {
          this.resetMedia();
        }
    }
  }
  /**
   * Shows the media corresponding with the block ID.
   * @param {String} blockId - The block ID for the selected block.
   */
  showBlockMedia(blockId) {
    this.swappableMediaArray.forEach((element) => {
      element.toggleAttribute(
        "data-media-active",
        element.getAttribute("data-block-id") == blockId
      );
    });
  }
  /**
   * Resets the media so the default media is shown.
   * @param {String} blockId - The block ID for the selected block.
   */
  resetMedia() {
    this.swappableMediaArray.forEach((element) => {
      if (element.getAttribute("data-block-id")) {
        element.removeAttribute("data-media-active");
      }
    });
  }
};
if (!customElements.get("fluco-collection-list")) {
  customElements.define("fluco-collection-list", CollectionList);
}
if (!customElements.get("fluco-collection-list-swappable-media")) {
  customElements.define(
    "fluco-collection-list-swappable-media",
    CollectionListSwappableMedia
  );
}
